import React from 'react';
import { Divider } from '@material-ui/core';
import PropTypes from 'prop-types';

const BodyTable = ({ data, history }) => {
  const editElement = (e, id) => {
    e.preventDefault();
    if (history?.location?.pathname) {
      history.push(`${history.location.pathname}/edit/${id}`);
    }
  };

  const handleKeyPress = (e, id) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      editElement(e, id);
    }
  };

  return (
    <div>
      <div className="cen-content-table">
        {data.map((el, index) => (
          <React.Fragment key={el.id || `item-${index}`}>
            <button
              type="button"
              className="cen-select"
              onClick={(e) => editElement(e, el.id)}
              onKeyDown={(e) => handleKeyPress(e, el.id)}
              aria-label={`Edit ${el.dialog_flow_id}`}
              style={{ background: 'none', border: 'none', padding: 0, width: '100%', textAlign: 'center' }}
            >
              <span>{el.dialog_flow_id}</span>
              <span>{el.lang}</span>
              <span>{el.centribot_project_id}</span>
              <span>{el.high_performance ? 'Yes' : 'No'}</span>
            </button>
            {index < data.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

BodyTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      dialog_flow_id: PropTypes.string,
      lang: PropTypes.string,
      centribot_project_id: PropTypes.string,
      high_performance: PropTypes.bool,
    })
  ).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }).isRequired,
};

export default BodyTable;